import { initFederation } from '@angular-architects/native-federation';
import { environment } from './environments/environment';

// Native federation's esbuild adapter only defines the `ngDevMode` global for optimized
// (prod-like) builds (see angular-esbuild-adapter.js's `!dev` check). On non-optimized envs
// (dev02/uatr/uatm/local) it's left unset, and Angular's compiler-generated signal debug-name
// code references it as a bare, unguarded global (unlike its other `typeof`-guarded checks) —
// crashing with "ReferenceError: ngDevMode is not defined" on first render. Set it ourselves,
// before anything else runs. Bracket notation avoids esbuild's `--define:ngDevMode=false`
// text substitution (applied on optimized builds) turning this into an invalid assignment.
(globalThis as Record<string, unknown>)['ngDevMode'] ??= true;

initFederation(environment.federationManifest)
  .catch(err => console.error(err))
  .then(() => import('./bootstrap'))
  .catch(err => console.error(err));
